import { useContext } from "../__compat__/react/main.entry.mjs.mjs";
import { ThemeContext } from "../__compat__/styled-components/main.entry.mjs.mjs";
export function useStyledTheme() {
    const theme = useContext(ThemeContext);
    return theme || {};
}
//# sourceMappingURL=useStyledTheme.mjs.mjs.map